<template>
  <div class="optWrap" :class="moveOptWrap">
    <button class="connectProcess" v-if="protocolType != 'UNIT' && (editorType && editorType ==='protocol')" @click="searchProcessNode">공정도 연결</button>
    <div class="publishWrap">
      <div class="publishStatus"><span :style="{'backgroundColor':`${publishColor[publicActive]}`}"></span>{{ publishText[publicActive] }}</div>
      <button @click="processOpen">공개하기</button>
    </div>
    <button v-if="editorType && editorType != 'protocol'" @click="endEditProcess">읽기모드</button>
    <button class="docOption" v-if="editorType !='protocol'" @click="gridVisible">격자옵션</button>
    <button class="docOption" v-if="editorType !='protocol'" @click="orderApply">순서적용</button>
    <button v-if="!status.nodeinfoViewBln" class="docOption" @click="preview">미리보기</button>
    <button v-if="!readonly" class="historySave" @click="save">저장</button>
    <button class="docOption" @click="updateStatus({'DocumentOption':true})">문서설정</button>
    <pdf-wiki ref="pdfWiki"/>
    <Loading :visible="loading" type="fixed"></Loading>
  </div>
  
</template>

<script>
import CommNew , {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import PDFWiki from "@components/pdf/PDFWiki";
import Loading from "@/components/common/loading.vue";

export default {
  data () {
    return {
      publishColor : ["#666666","#50AF79","#F0BD22"],
      publishText : ["미공개","일반회원 이상 공개","위원,간사 공개"],
      publicActive : 0,
      viewerData: {},
      previewActive: true,
      editorType:'process',
      loading: false,
    }
  },
  mixins:[ CommNew ] , 
  components : {
    Loading,
    'pdf-wiki' : PDFWiki , 
  } , 
  props : {
    readonly : { type: Boolean, default: false },
    protocolType : { type: String, default: "" },
    openSaveLogPopup : { type: Function, default: ()=>{} } , 
    openPublishPopup : { type: Function, default: ()=>{} } , 
    openLogListPopup : { type: Function, default: ()=>{} } , 
  } , 
  beforeMount () {
    this.moveInit() ; 
  } , 
  async mounted () {
    if( this.$route.query.editorType ) this.editorType = this.$route.query.editorType;
    await this.getReleasData();
  } , 
  computed : {
    moveOptWrap () {
      return this.status.nodeinfoViewBln ? null : 'move';
    } ,
    user() {
      return this.$store.state.user;
    },
  } ,
  methods : {
    ...commNewMapMutations([
      'updateStatus' , 
    ]) ,
    async processOpen(){
      this.openPublishPopup();
    },
    async getReleasData() {
      try {
        this.loading = true;
        if (this.editorType == "protocol") {
          let response = await this.$wApi.protocol.release.get({protocolId: this.$route.query.protocolId});
          if (response?.error || response == null) {
            this.publicActive = 0;
            this.loading = false;
            return;
          }
          this.publicActive = response.publicActive ?? 0;
        } else if (this.editorType == "process") {
          let response = await this.$wApi.process.release.get({processId: this.$route.query.processId});
          if (response?.error || response == null) {
            this.publicActive = 0;
            this.loading = false;
            return;
          }
          this.publicActive = response.publicActive ?? 0;
        }
      } catch (e) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async pdfView(){
      if(this.$route.query.editorType && this.$route.query.editorType == 'protocol') {
        const {processId, protocolId, keyOfProtocol} = this.$route.query;
        let currnet = this.PROCESS_INFO.protocols.filter( o => o.id == protocolId)

        // if( currnet[0].protocolType === 'UNIT' ){
        //   window.alert('UNIT 프로토콜은 PDF보기가 지원되지 않습니다.');
        //   return;
        // }else{
        //   let {href} =  this.$router.resolve({
        //     path: '/pdfdownload/wikiCapture',
        //     query: {
        //       processId, protocolId : currnet[0].id, key: protocolId
        //     }
        //   });
        //   let printPage = window.open( href , '_blank' ) ; 
        // }

        let {href} =  this.$router.resolve({
          path: '/pdfdownload/wikiCapture',
          query: {
            processId, protocolId : protocolId, key: keyOfProtocol
          }
        });
        let printPage = window.open( href , '_blank' ) ; 
        
      }
    },
    preview() {
      let { processId, protocolId } = this.$route.query;
      let currnet = this.PROCESS_INFO.protocols.filter( o => o.id == protocolId)
      this.updateStatus({wikiPreviewerStatus: {
        visible: true,
        processId : processId, 
        protocolId : currnet[0].id
      }})
    },
    moveInit () {
      // console.log('MoveInit')
      switch ( this.$route.query.editorType ) {
        case 'process' : 
          // this.updateStatus({ nodeinfoViewBln : false }) ; 
          // 요청의 의해 노드 정보 노출 기본 설정이 true로 변경
          this.updateStatus({ nodeinfoViewBln : true }) ; 
          break ; 
        case 'protocol' : 
          this.updateStatus({ nodeinfoViewBln : false }) ; 
          break ; 
      }
    } ,
    gridVisible(){
      this.$emit('gridVisible')
    },
    orderApply(){
      this.$emit('orderApply');
    },
    async callUtil() {
      const flag = await window.confirm(`해당 Full 프로토콜을 Unit으로 분할하시겠습니까?`);
      if (flag) {
        this.loading = true;
        let {processId, protocolId} = this.$route.query;
        let currnet = this.PROCESS_INFO.protocols.filter(o => o.id == protocolId)
        protocolId = currnet[0].id;
        const ignoreParentNodeList = ["작성자", "공정도", "용어설명"];
        let parents = [];
        currnet[0].json.issues.forEach(node => {
          if (node.P && !ignoreParentNodeList.includes(node.text)) {
            parents.push(node.text);
          }
        });
        let data = await this.$wApi.protocol.callUtil({
          processId: Number(processId),
          protocolId: protocolId,
          parents: parents.join(','),
        });
        if(data && !data.error){
          window.alert("유닛프로토콜로 분할이 완료되었습니다.");
        }else{
          window.alert("유닛프로토콜로 분할중 오류가 발생했습니다.");
        }
        this.loading = false;
      }
    },
    async endEditProtocol(){
      /*전체링크 관리모드*/
      this.$emit('endEditProtocol');
      /*const flag = await window.confirm(`관리모드 이동 전 저장을 해주세요. <br/> 저장키 : [CTRL + S] `);
      if (flag) {
        this.$router.go(this.$router.currentRoute);
      }*/
    },
    save(){
      //this.$emit('saveRequest');
      this.$emit('orderApply');
    },
    endEditProcess(){
      this.$emit('endEditProcess');
    },
    searchProcessNode(){
      this.$emit('searchProcessNode') ;
    },

  } ,
  
}
</script>

<style lang="scss" scoped>
  @import "@/style/new/css/cyl.common.css";

  .optWrap {
    --gap: 8px; 
    --size: 32px; 
    position: fixed; bottom:320px; right:20px;
    display: flex; 
    // flex-wrap: wrap; 
    width: 125px; 
    gap: var( --gap ); 
    z-index: 92;
    transition: transform 0.3s ease;
    transform: translateX(calc(var( --nodeinfo-width ) * -1 )); 
    justify-content: end;
    
    .connectProcess{
      position:absolute;
      right:135px;
      bottom:40px;
      width: 120px;
    }
    
    .publishWrap{
      position:absolute;
      right:0;
      bottom:40px;
      width: 125px;
      
      >button{
        display: flex; 
        border: 1px solid #6C79A8; 
        width: 100%; 
        height: var( --size ); 
        justify-content: center; 
        align-items: center; 
        font-size: 14px; 
        color: $gray-3; 
        flex-shrink: 0; 
        @include text-prt-sb;    
        background-color: #F0F6FF;
        &:after {
          content:'';
          display: inline-block; width:14px; height: 14px;
          margin-right: 5px;
          background: url('@/assets/icons/icon-publish.svg') center no-repeat;
        }        
      }
      >.publishStatus{
        display:flex;
        justify-content: flex-end;
        align-items: center;
        padding-bottom:5px;
        @include text-prt-sb;    
        font-size:14px;
        >span{
          display:block;
          width:10px;height:10px;
          border-radius:50%;
          margin-right:5px;
        }
      }
    }
    &.move {
      transform: translateX( 0 ); 
    }
    > button , > a {
      display: flex; 
      border: 1px solid $gray-d; 
      width: 100%; 
      height: var( --size ); 
      justify-content: center; 
      background-color: #fff;
      align-items: center; 
      font-size: 14px; 
      color: $gray-3; 
      flex-shrink: 0; 
      @include text-prt-sb; 
      &.docOption {
        width: calc( 100% - var( --size ) - var( --gap )); 
      } 
      &.historyList {
        font-size: 0; 
        background: url('@/assets/icons/clock.svg') no-repeat center center #fff; 
        width: 32px; 
        flex-shrink: 0; 
      }
      &.historySave {
        background-color: $gray-e; 
      }
    }
  }

  .wikiViewerPopup {
    @include modalLayoutBlur;
    
  }
</style>